import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import CustomDateSelectionDropdown, {
  DateType,
} from '../../_components/molecules/CustomDateSelectionDropdown';
import AutocompleteWithCheckBoxes from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Autocomplete';
import { useStores } from '../../stores';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import {
  getAvailableDates as getAvailableDatesAPI,
  getFinancialForensicsData,
} from '../../core-utils/axios/financials/financial';
import Snackbar from '../../_components/atoms/Snackbar';
import {
  DataForReconciliation,
  DocumentDetailsForModal,
  emptyDataForReconciliation,
  emptyDocumentDetailsForModal,
  emptyReconciliationInfo,
  Reconciliation,
} from './ReconciliationWorkspace.types';
import {
  addBuildReconciliation,
  addReconciliation,
  fetchAddReconciliations,
  fetchReconciliations,
  updateAddReconciliation,
  uploadReconciliationFiles,
} from '../../core-utils/axios/financials/reconciliations';
import { useLocation } from 'react-router-dom';
import Loader from '../../_components/molecules/Loader';
import AddBuildScenarioModal from '../../_components/organisms/AddBuildScenarioModal';
import { ReconcilationInfo } from '../../_components/organisms/ReconciliationModal';
import {
  buildReconciliationColumn,
  computeUpdatedFixedCost,
  computeUpdatedVariableCost,
  formatDocuments,
  formatSavedReconciliation,
  mapFixedType,
  reconciliationDocumentsColumns,
  updateEmployeeCountWithReconciliation,
  updateVendorsWithReconciliation,
} from '../../core-utils/helper-utils/financialForensics/reconciliationHelper';
import TabSelection from '../../_components/molecules/TabSelection';
import Financials from '../../_components/organisms/FinancialsTab';
import {
  calculateContributions,
  calculateVariableContributions,
  getFixedCostColumns,
  getVariableCostColumns,
} from '../../core-utils/helper-utils/financialForensicsHelper';
import {
  FeeCalculationModalType,
  getEmptyFeeCalculationModalState,
  getEmptyOtherClaimsModalState,
  getEmptyReimbursementModalState,
  OtherClaimsModalType,
  ReimbursementModalType,
  RowType,
  TableType,
} from '../FinancialForensicsPage/FinancialForensics.types';
import { getRowType } from '../../core-utils/helper-utils/buildScenarioHelper';
import {
  emptyFixedCostFeeCalculation,
  FixedCost,
  FixedCostFeeCalculation,
  getEmptyFixedCost,
} from '../FinancialForensicsPage/types/FixedCost.types';
import {
  VariableCost,
  VendorEntry,
  emptyVendorEntry,
  getEmptyVariableCost,
} from '../FinancialForensicsPage/types/VariableCost.types';
import FeeCalculationModal from '../../_components/organisms/FeeCalculationModal';
import axios from 'axios';
import properties from '../../core-utils/properties';
import AddOtherClaimLineModal from '../../_components/organisms/AddOtherClaimLineModal';
import AddReimbursementModal from '../../_components/organisms/AddReimbursementModal';
import {
  BaseEntry,
  BreakdownEntry,
  EmployeeCount,
  EmployeeCountModalProps,
  emptyEmployeeCountModalData,
  FormatType,
  getEmptyEmployeeCount,
} from '../FinancialForensicsPage/types/EmployeeCount.types';
import EmployeeCountTab from '../../_components/organisms/EmployeeCountTab';
import AddEmployeeCountModal from '../../_components/organisms/AddEmployeeCountModal';
import {
  formatEmployeeCountModalData,
  formatUpdatedEmployeeCount,
} from '../../core-utils/helper-utils/financialForensics/employeeCountHelper';
import { getPreviousYearDates } from '../../core-utils/helper-utils/helper';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import DocumentViewModal from '../../_components/molecules/DocumentViewModal';
import { createBlobUrl } from '../../core-utils/helper-utils/contractAIQHelper';
import FiscalControlDocumentsTab from '../../_components/organisms/FiscalControlDocumentsTab';
import DocumentUploadModal from '../../_components/organisms/DocumentUploadModal';
import useDocumentUpload from '../../core-utils/custom-hooks/DocumentUpload';

export const getTitleTypography = (label: string) => {
  return (
    <Typography
      fontSize="18px"
      lineHeight="100%"
      textColor={patientAccessTheme.palette.text.highemphasis}
      fontType="semiBold"
    >
      {label}
    </Typography>
  );
};

export const getSubTextTypography = (label: string) => {
  return (
    <Typography
      fontSize="17px"
      lineHeight="100%"
      textColor={patientAccessTheme.palette.text.mediumemphasis}
      fontType="semiBold"
    >
      {label}
    </Typography>
  );
};

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '1276px',
    padding: '40px 0px 66px 63px',
  },

  titleFlex: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  addScenarioButton: {
    padding: '5px 10px',
    border:
      '0.5px dashed ' + patientAccessTheme.palette.chips.autoCompleteComponent,
    background: patientAccessTheme.palette.grey[300],
    '&:hover': {
      background: patientAccessTheme.palette.grey[300],
      border:
        '0.5px dashed ' +
        patientAccessTheme.palette.chips.autoCompleteComponent,
    },
  },
  employeeCountContainer: {
    marginTop: '1rem',
  },
});

const ReconciliationWorkspace = () => {
  const { classes } = useStyles();

  const location: any = useLocation();
  const fiscalControlStore = useStores().fiscalControlStore;
  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;

  const { snackbarState, handleCloseSnackBar, openSnackbar } = useSnackbar();

  const { startDate, endDate } = fiscalControlStore;
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const email = loginPageStore.email;

  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [avaiableDates, setAvaiableDates] = useState<DateType[]>([]);
  const [selectedDates, setSelectedDates] = useState<DateType>({
    startDate: startDate,
    endDate: endDate,
  });
  const [reconciliations, setReconciliations] = useState<Reconciliation[]>([]);
  const [
    selectedReconciliationNames,
    setSelectedReconciliationNames,
  ] = useState<string[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [
    reconciliationInfo,
    setReconciliationInfo,
  ] = useState<ReconcilationInfo>(emptyReconciliationInfo());

  const [employeeCount, setEmployeeCount] = useState<EmployeeCount>(
    getEmptyEmployeeCount(),
  );
  const [fixedCost, setFixedCost] = useState<FixedCost>(getEmptyFixedCost());
  const [variableCost, setVariableCost] = useState<VariableCost>(
    getEmptyVariableCost(),
  );

  const [sourceOfDataOptions, setSourceOfDataOptions] = useState<string[]>([]);
  const [
    sourceOfDataOptionsEmployees,
    setSourceOfDataOptionsEmployees,
  ] = useState<string[]>([]);
  const [
    selectedEmployeeCountType,
    setSelectedEmployeeCountType,
  ] = useState<FormatType>('count');

  //----Modal States--------------------------------------
  const [
    openOtherClaimLineModal,
    setOpenOtherClaimLineModal,
  ] = useState<OtherClaimsModalType>(getEmptyOtherClaimsModalState());
  const [
    openReimbursementModal,
    setOpenReimbursementModal,
  ] = useState<ReimbursementModalType>(getEmptyReimbursementModalState());
  const [
    openAddReconciliationModal,
    setOpenAddReconciliationModal,
  ] = useState<FeeCalculationModalType>(getEmptyFeeCalculationModalState());
  const [employeeCountModalOpen, setEmployeeCountModalOpen] = useState<boolean>(
    false,
  );
  const [documentModalOpen, setDocumentModalOpen] = useState<boolean>(false);

  //----Modal Data States--------------------------------

  const [documentToOpen, setDocumentToOpen] = useState<DocumentDetailsForModal>(
    emptyDocumentDetailsForModal(),
  );
  const [
    dataForReconciliation,
    setDataForReconciliation,
  ] = useState<DataForReconciliation>(emptyDataForReconciliation());
  const [
    dataForPropsAddReconciliation,
    setdataForPropsAddReconciliation,
  ] = useState<FixedCostFeeCalculation>(emptyFixedCostFeeCalculation());

  const [
    dataForPropsVariableFees,
    setdataForPropsVariableFees,
  ] = useState<VendorEntry>(emptyVendorEntry());

  const [
    dataForPropsFinancialAdjustments,
    setdataForPropsFinancialAdjustments,
  ] = useState<VendorEntry>(emptyVendorEntry());
  const [
    employeeCountModalDataProps,
    setEmployeeCountModalDataProps,
  ] = useState<EmployeeCountModalProps>(emptyEmployeeCountModalData());

  const baseFixedColumns = getFixedCostColumns(
    () => {},
    () => {},
  );
  const baseVariableColumns = getVariableCostColumns(() => {});
  const prevSelectedNamesRef = useRef<string[]>([]);

  const selectedReconciliations = useMemo(() => {
    const selectedSet = new Set(selectedReconciliationNames);

    return reconciliations.filter((r) => selectedSet.has(r.name));
  }, [reconciliations, selectedReconciliationNames]);

  const [
    selectedEmployeeSourceName,
    setSelectedEmployeeSourceName,
  ] = useState<string>('Projected');

  const filteredEmployeeCount = useMemo(() => {
    if (
      !selectedEmployeeSourceName ||
      selectedEmployeeSourceName === 'Projected'
    ) {
      return employeeCount;
    }

    const filterBaseEntry = (entry: BaseEntry): BaseEntry =>
      ((entry as any)[selectedEmployeeSourceName] as BaseEntry) ?? entry;

    const filterBreakdownEntry = (entry: BreakdownEntry): BreakdownEntry =>
      ((entry as any)[selectedEmployeeSourceName] as BreakdownEntry) ?? entry;

    return {
      employees: filterBaseEntry(employeeCount.employees),
      members: filterBaseEntry(employeeCount.members),
      membersBySubscriptionType: filterBreakdownEntry(
        employeeCount.membersBySubscriptionType,
      ),
      employeeBySubscriptionType: filterBreakdownEntry(
        employeeCount.employeeBySubscriptionType,
      ),
      employeeByPlanType: filterBreakdownEntry(
        employeeCount.employeeByPlanType,
      ),
      memberByPlanType: filterBreakdownEntry(employeeCount.memberByPlanType),
    };
  }, [selectedEmployeeSourceName, employeeCount]);

  const { prevStartDate, prevEndDate } = getPreviousYearDates(
    selectedDates.startDate,
    selectedDates.endDate,
  );

  //----Handlers--------------------------------------
  const handleSelectedTabIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  const handleEmployeeSourceChange = (event: any) => {
    const value = event.target.value as string;
    setSelectedEmployeeSourceName(value);
  };
  const handleChangeReconciliation = (reconciliationNames: string[]) => {
    setSelectedReconciliationNames(reconciliationNames ?? []);
  };
  const handleAutocompleteChange = useCallback(
    (_event: any, value: string[]) => {
      handleChangeReconciliation(value);
    },
    [handleChangeReconciliation],
  );
  const handleModalClose = () => {
    setIsOpen(false);
    setReconciliationInfo(emptyReconciliationInfo());
  };
  const handleSaveReconciliation = async () => {
    const { totalFixedCost } = calculateContributions(fixedCost, []);
    const { totalVariableCost } = calculateVariableContributions(variableCost);
    const savedReconciliation = await addReconciliation(
      egNid,
      reconciliationInfo,
      email,
      selectedDates?.startDate,
      selectedDates?.endDate,
      totalFixedCost,
      totalVariableCost,
      openSnackbar,
    );

    if (savedReconciliation) {
      await addBuildReconciliation(
        egNid,
        savedReconciliation?._id,
        selectedDates?.startDate,
        selectedDates?.endDate,
        openSnackbar,
      );

      setReconciliations((prev) => [
        ...prev,
        formatSavedReconciliation(savedReconciliation),
      ]);
      setSelectedReconciliationNames((prev) => [
        ...prev,
        savedReconciliation?.reconciliationName,
      ]);
      updateReconciliationData(
        savedReconciliation?._id,
        savedReconciliation?.reconciliationName,
      );
      handleModalClose();
    }
  };

  const updateFieldNamesForSourceOfData = async (
    value: string,
    field: string,
  ) => {
    if (field === 'source_of_data') {
      setSourceOfDataOptions((prevOptions) => {
        if (prevOptions.includes(value)) {
          return prevOptions;
        }
        return [...prevOptions, value];
      });
    } else if (field === 'source_of_data_employees') {
      setSourceOfDataOptionsEmployees((prevOptions) => {
        if (prevOptions.includes(value)) {
          return prevOptions;
        }
        return [...prevOptions, value];
      });
    }

    try {
      await axios.post(
        properties.aiqBaseUrl +
          properties.dynamicFieldsBaseUrl +
          properties.addDynamicFields,
        {
          field,
          value,
        },
      );
    } catch (error) {
      openSnackbar('Error Updating Source of Data', 'error', 2000);
    }
  };

  const handleFeeUpdate = async (
    updatedCalculation: FixedCostFeeCalculation,
  ) => {
    const {
      vendorId,
      serviceId,
      reconciliationId,
      reconciliationName,
      type,
    } = dataForReconciliation;

    let finalFee = 0;

    setFixedCost((prev) => {
      const { updatedState, updatedFee } = computeUpdatedFixedCost(
        prev,
        vendorId,
        serviceId,
        reconciliationName,
        updatedCalculation,
      );

      finalFee = updatedFee;

      return {
        ...prev,
        ...updatedState,
      };
    });

    await updateAddReconciliation(
      egNid,
      reconciliationId,
      vendorId,
      serviceId,
      updatedCalculation,
      finalFee,
      type,
      'FIXED',
      openSnackbar,
    );
  };
  const handleVariableUpdate = async (
    data: any,
    target: 'FEES' | 'REBATES',
  ) => {
    const {
      vendorId,
      serviceId,
      reconciliationId,
      reconciliationName,
      type,
    } = dataForReconciliation;

    let finalFee = 0;

    setVariableCost((prev) => {
      const { updatedState, updatedFee } = computeUpdatedVariableCost(
        prev,
        vendorId,
        reconciliationName,
        data,
        target,
      );

      finalFee = updatedFee;
      return updatedState;
    });

    await updateAddReconciliation(
      egNid,
      reconciliationId,
      vendorId,
      serviceId,
      data.feeCalculation,
      finalFee,
      type,
      'VARIABLE',
      openSnackbar,
    );
  };
  const handleSubmitEmployeeDetails = async (data: any) => {
    try {
      if (selectedEmployeeSourceName === 'Projected') {
        return;
      }
      setLoading(true);
      const updatedData = formatUpdatedEmployeeCount(
        selectedEmployeeCountType,
        data,
      );

      const reconciliationId = reconciliations.find(
        (item) => item.name === selectedEmployeeSourceName,
      )?.id;

      if (!reconciliationId) {
        return;
      }
      await axios.post(
        properties.aiqBaseUrl +
          properties.financialForensicsBaseURL +
          properties.updateEmployeeCountAddReconciliation,
        {
          egNid: employerGroupStore.employerGroupResponseData.eg_nid,
          employeeCountData: { ...filteredEmployeeCount, ...updatedData },
          reconciliationId,
        },
      );

      updateReconciliationData(reconciliationId, selectedEmployeeSourceName);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleAddEmployeeDetails = async (employeeCountType: FormatType) => {
    const dataProps = formatEmployeeCountModalData(
      employeeCountType,
      filteredEmployeeCount,
    );
    setEmployeeCountModalDataProps(dataProps);
    setSelectedEmployeeCountType(employeeCountType);
  };

  const handleDocumentToOpen = async (fileName: string, rawURL: string) => {
    const url = await createBlobUrl(rawURL);
    setDocumentToOpen({ title: fileName, url });
    setDocumentModalOpen(true);
  };

  const handleReconciliationUpload = async (
    files: File[],
    selectedOption: string | null,
  ) => {
    const reconciliationId = reconciliations.find(
      (item) => item.name === selectedOption,
    )?.id;

    if (!reconciliationId) {
      return;
    }

    const response = await uploadReconciliationFiles(
      egNid,
      reconciliationId,
      selectedDates.startDate,
      selectedDates.endDate,
      loginPageStore.userId,
      files,
    );
    const newDocs = response.data.data;

    setReconciliations((prev) =>
      prev.map((rec) =>
        rec.id === reconciliationId
          ? { ...rec, documents: [...rec.documents, ...newDocs] }
          : rec,
      ),
    );
  };

  const {
    isModalOpen,
    uploadedFiles,
    selectedOption: selectedModaReconciliation,
    openModal,
    closeModal,
    handleSelectOption,
    handleSubmit,
    setUploadedFiles,
  } = useDocumentUpload<string>({
    onUpload: handleReconciliationUpload,
    onError: () => openSnackbar('Error Uploading files', 'error', 2000),
    requiresSelection: true,
  });

  //---Functions
  const mapReconciliation = (item: any): Reconciliation => ({
    id: item?._id,
    name: item?.reconciliationName || '',
    notes: item?.notes || '',
    documents: item?.documents || [],
  });

  const resolveCurrentReconciliation = (
    fetchedReconciliations: any[],
    reconciliationId?: string,
  ): Reconciliation => {
    if (reconciliationId) {
      const found = fetchedReconciliations.find(
        (item) => item?._id === reconciliationId,
      );
      return mapReconciliation(found || {});
    }
    return mapReconciliation(fetchedReconciliations[0] || {});
  };

  const openModalByContext = (
    tableType: TableType,
    rowType: RowType,
    row: any,
    vendor: any,
    col: any,
  ) => {
    const cellData = row?.[col?.name];

    setDataForReconciliation({
      vendorId: vendor?.vendorID ?? '',
      reconciliationId: cellData?.id ?? '',
      reconciliationName: col?.name ?? '',
      serviceId: row?.serviceID ?? '',
      tableType,
      type: getRowType(rowType, tableType),
    });

    if (tableType === 'FIXED') {
      if (cellData?.isChosen) {
        setdataForPropsAddReconciliation(cellData.feeCalculation);
      }

      setOpenAddReconciliationModal({
        open: true,
        unitOfFees: row.unitOfFees,
        actionType: 'ADD',
        selectedVendorID: vendor.vendorID,
        selectedServiceID: row.serviceID,
        type: mapFixedType(rowType),
      });

      return;
    }

    if (
      tableType === 'VARIABLE' &&
      (rowType === 'primary' || rowType === 'member')
    ) {
      setdataForPropsVariableFees(
        cellData?.isChosen
          ? cellData
          : {
              ...emptyVendorEntry(),
              claims: row?.claims,
            },
      );

      setOpenOtherClaimLineModal({
        open: true,
        type: 'FEES',
        actionType: 'ADD',
        selectedVendorID: row.vendorID,
      });

      return;
    }

    if (tableType === 'VARIABLE' && rowType === 'secondary') {
      setdataForPropsFinancialAdjustments(
        cellData?.isChosen
          ? cellData
          : {
              ...emptyVendorEntry(),
              claims: row?.claims,
              entryType: row?.entryType,
            },
      );

      setOpenReimbursementModal({
        open: true,
        type: 'REBATES',
        actionType: 'ADD',
        selectedVendorID: row.vendorID,
      });
    }
  };

  const updateReconciliationData = async (
    reconciliationId: string,
    reconciliationName: string,
  ) => {
    const buildReconciliation = await fetchAddReconciliations(
      egNid,
      reconciliationId,
      startDate,
      endDate,
    );

    setEmployeeCount((prev) =>
      updateEmployeeCountWithReconciliation(
        prev,
        buildReconciliation?.employeeCount,
        reconciliationName,
      ),
    );

    setFixedCost((prev) => ({
      ...prev,
      planContribution: {
        ...prev.planContribution,
        fees: updateVendorsWithReconciliation(
          prev?.planContribution?.fees,
          buildReconciliation?.fixedCost?.planContribution?.fees,
          reconciliationName,
          reconciliationId,
          true,
        ),
        credits: updateVendorsWithReconciliation(
          prev?.planContribution?.credits,
          buildReconciliation?.fixedCost?.planContribution?.credits,
          reconciliationName,
          reconciliationId,
          true,
        ),
      },
      memberContribution: updateVendorsWithReconciliation(
        prev?.memberContribution,
        buildReconciliation?.fixedCost?.memberContribution,
        reconciliationName,
        reconciliationId,
        true,
      ),
    }));

    setVariableCost((prev) => ({
      ...prev,
      planContribution: {
        ...prev.planContribution,
        fees: updateVendorsWithReconciliation(
          prev?.planContribution?.fees,
          buildReconciliation?.variableCost?.planContribution?.fees,
          reconciliationName,
          reconciliationId,
          false,
        ),
        rebates: updateVendorsWithReconciliation(
          prev?.planContribution?.rebates,
          buildReconciliation?.variableCost?.planContribution?.rebates,
          reconciliationName,
          reconciliationId,
          false,
        ),
      },
      memberContribution: updateVendorsWithReconciliation(
        prev?.memberContribution,
        buildReconciliation?.variableCost?.memberContribution,
        reconciliationName,
        reconciliationId,
        false,
      ),
    }));
  };

  const fixedCostColumns = useMemo(() => {
    const reconciliationColumns = selectedReconciliations.map((r) =>
      buildReconciliationColumn(r, 'FIXED', openModalByContext),
    );

    return [...baseFixedColumns, ...reconciliationColumns];
  }, [selectedReconciliations, baseFixedColumns]);

  const variableCostColumns = useMemo(() => {
    const reconciliationColumns = selectedReconciliations.map((r) =>
      buildReconciliationColumn(r, 'VARIABLE', openModalByContext),
    );

    return [...baseVariableColumns, ...reconciliationColumns];
  }, [selectedReconciliations, baseVariableColumns]);

  //---APIs------------------------------------------
  const getReconciliations = async () => {
    const data = await fetchReconciliations(
      egNid,
      selectedDates?.startDate,
      selectedDates?.endDate,
    );
    const fetchedReconciliations = data?.reconciliations || [];

    setReconciliations(fetchedReconciliations.map(mapReconciliation));

    const currentReconciliation = resolveCurrentReconciliation(
      fetchedReconciliations,
      location?.state?.reconciliationId,
    );

    setSelectedReconciliationNames([currentReconciliation.name]);
    return currentReconciliation;
  };

  const getAvailableDates = async () => {
    try {
      const response = await getAvailableDatesAPI(egNid);
      setAvaiableDates(response.data.data);
    } catch (error) {
      openSnackbar('Error Fetching Plan Dates', 'error', 2000);
    }
  };
  const getFieldNamesForSourceOfData = async () => {
    return await axios.post(
      properties.aiqBaseUrl +
        properties.dynamicFieldsBaseUrl +
        properties.getDynamicFields,
      {
        field: ['source_of_data', 'source_of_data_employees'],
      },
    );
  };

  const APICalls = async () => {
    try {
      setLoading(true);
      const responses = await Promise.allSettled([
        getFinancialForensicsData(
          egNid,
          selectedDates.startDate,
          selectedDates.endDate,
          employerGroupStore.employerGroupResponseData.max_claim_date,
        ),
        getFieldNamesForSourceOfData(),
        getReconciliations(),
      ]);

      if (responses[0].status === 'fulfilled') {
        const response = responses[0].value.data.data;
        setEmployeeCount(response.employeeCount);
        setFixedCost(response.fixedCost);
        setVariableCost(response.variableCost);
      }
      if (responses[1].status === 'fulfilled') {
        const response = responses[1].value.data.data;
        setSourceOfDataOptions(response.source_of_data);
        setSourceOfDataOptionsEmployees(response.source_of_data_employees);
      }
      if (responses[2].status === 'fulfilled') {
        const currentReconciliation = responses[2].value;
        await updateReconciliationData(
          currentReconciliation.id,
          currentReconciliation.name,
        );
      }
    } catch (error) {
      openSnackbar('Error Feteching API', 'error', 2000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!egNid) {
      return;
    }
    getAvailableDates();
  }, [egNid]);

  useEffect(() => {
    if (selectedDates.startDate === '' && selectedDates.endDate === '') {
      return;
    }
    APICalls();
  }, [selectedDates.startDate, selectedDates.endDate]);

  useEffect(() => {
    const prevNames = prevSelectedNamesRef.current;
    const newlyAdded = selectedReconciliations.filter(
      (r) => !prevNames.includes(r.name),
    );

    if (newlyAdded.length > 0) {
      setLoading(true);
      Promise.allSettled(
        newlyAdded.map((r) => updateReconciliationData(r.id, r.name)),
      ).finally(() => setLoading(false));
    }

    prevSelectedNamesRef.current = selectedReconciliationNames;
  }, [selectedReconciliationNames]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Grid container className={classes.root}>
      <Grid>
        <PageTitleAndSubTitle
          title={
            <Box className={classes.titleFlex}>
              {getTitleTypography('Reconciliation Workspace')}
              {getSubTextTypography('built on baseline')}
              <CustomDateSelectionDropdown
                setSelectedDates={setSelectedDates}
                availableDates={avaiableDates}
              />
            </Box>
          }
          subTitle={''}
        />
        <Grid className={classes.titleFlex}>
          <Typography
            fontSize="14px"
            fontType="regular"
            lineHeight="16.8px"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin={`11px 0px 15px 0px`}
          >
            Reconciliations
          </Typography>
          <AutocompleteWithCheckBoxes
            options={reconciliations?.map((item) => item?.name)}
            defaultValue={selectedReconciliations?.map((item) => item?.name)}
            placeholder={
              selectedReconciliations?.length > 0
                ? ''
                : 'Select Reconciliations'
            }
            noOptionsLabel="No Reconciliations Found"
            handleChange={handleAutocompleteChange}
          />
          <Button
            label={
              <Typography
                fontSize="12px"
                lineHeight="100%"
                textColor={patientAccessTheme.palette.grey[700]}
                fontType="medium"
              >
                + Add Reconciliation
              </Typography>
            }
            variant="outlined"
            className={classes.addScenarioButton}
            height="22px"
            width="auto"
            onClick={() => setIsOpen(true)}
          />
        </Grid>
      </Grid>
      <Grid>
        <>
          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedTabIndex}
            tabList={['Financials', 'Employee Count', 'Documents']}
          />
          {selectedTabIndex === 0 && (
            <Financials
              fixedCostColumns={fixedCostColumns}
              variableCostColumns={variableCostColumns}
              fixedPrimary={fixedCost?.planContribution?.fees}
              fixedSecondary={fixedCost?.planContribution?.credits}
              fixedMember={fixedCost?.memberContribution ?? []}
              variablePrimary={variableCost?.planContribution?.fees}
              variableSecondary={variableCost?.planContribution?.rebates}
              variableMember={variableCost?.memberContribution ?? []}
              fixedCostTableLoading={false}
              variableCostTableLoading={false}
            />
          )}
          {selectedTabIndex === 1 && (
            <Grid className={classes.employeeCountContainer}>
              <Dropdown
                label={'Select Source'}
                dropDownOptions={['Projected', ...selectedReconciliationNames]}
                dropDownValues={['Projected', ...selectedReconciliationNames]}
                value={selectedEmployeeSourceName}
                setValue={setSelectedEmployeeSourceName}
                handleChange={handleEmployeeSourceChange}
                width="300px"
                selectStyles={{ width: '300px' }}
              />

              <EmployeeCountTab
                employeeCountData={filteredEmployeeCount}
                setEmployeeCountModalOpen={setEmployeeCountModalOpen}
                handleAddEmployeeDetails={handleAddEmployeeDetails}
                isMainPage={false}
              />
            </Grid>
          )}
          {selectedTabIndex === 2 && (
            <FiscalControlDocumentsTab
              rowData={formatDocuments(reconciliations, handleDocumentToOpen)}
              handleAddNewDocument={openModal}
              tableTitle={'Reconciliation Documents'}
              columns={reconciliationDocumentsColumns}
            />
          )}
        </>
      </Grid>
      {employeeCountModalOpen && (
        <AddEmployeeCountModal
          open={employeeCountModalOpen}
          setOpen={setEmployeeCountModalOpen}
          handleSubmit={handleSubmitEmployeeDetails}
          handleOpenSnackBar={() => {}}
          startDate={
            selectedEmployeeSourceName === 'Projected'
              ? prevStartDate
              : selectedDates?.startDate
          }
          endDate={
            selectedEmployeeSourceName === 'Projected'
              ? prevEndDate
              : selectedDates?.endDate
          }
          sourceOfDataOptions={sourceOfDataOptionsEmployees}
          updateFieldNamesForSourceOfData={updateFieldNamesForSourceOfData}
          dataFromProps={employeeCountModalDataProps}
          handleCloseModal={() =>
            setEmployeeCountModalDataProps(emptyEmployeeCountModalData())
          }
        />
      )}
      {isOpen && (
        <AddBuildScenarioModal
          open={isOpen}
          handleModalClose={handleModalClose}
          handleConfirm={handleSaveReconciliation}
          scenarioInfo={reconciliationInfo}
          setScenarioInfo={setReconciliationInfo}
          title="Add Reconciliation"
          fieldName="Reconciliation Name*"
          fieldPlaceholder="Enter Reconciliation Name"
        />
      )}
      {openAddReconciliationModal && (
        <FeeCalculationModal
          open={openAddReconciliationModal}
          setOpen={setOpenAddReconciliationModal}
          onClose={() => {
            setdataForPropsAddReconciliation(emptyFixedCostFeeCalculation());
          }}
          handleSubmit={(data) => {
            handleFeeUpdate(data);
          }}
          sourceOfDataOptions={sourceOfDataOptions}
          updateFieldNamesForSourceOfData={updateFieldNamesForSourceOfData}
          handleOpenSnackBar={openSnackbar}
          startDate={selectedDates?.startDate}
          endDate={selectedDates?.endDate}
          dataFromProps={dataForPropsAddReconciliation}
        />
      )}
      {openOtherClaimLineModal && (
        <AddOtherClaimLineModal
          open={openOtherClaimLineModal}
          setOpen={setOpenOtherClaimLineModal}
          onClose={() => {
            setdataForPropsVariableFees(emptyVendorEntry());
          }}
          handleSubmit={(data) => handleVariableUpdate(data, 'FEES')}
          startDate={selectedDates.startDate}
          endDate={selectedDates.endDate}
          handleDelete={() => {}}
          dataFromProps={dataForPropsVariableFees}
        />
      )}
      {openReimbursementModal && (
        <AddReimbursementModal
          open={openReimbursementModal}
          setOpen={setOpenReimbursementModal}
          onClose={() => {
            setdataForPropsFinancialAdjustments(emptyVendorEntry());
          }}
          handleSubmit={(data) => handleVariableUpdate(data, 'REBATES')}
          handleOpenSnackBar={() => {}}
          startDate={selectedDates.startDate}
          endDate={selectedDates.endDate}
          dataFromProps={dataForPropsFinancialAdjustments}
          vendorOptions={[]}
          typeOptions={[]}
          handleDelete={() => {}}
        />
      )}
      {isModalOpen && (
        <DocumentUploadModal
          open={isModalOpen}
          handleClose={closeModal}
          handleSubmit={handleSubmit}
          uploadedFiles={uploadedFiles}
          setUploadedFiles={setUploadedFiles}
          dropdownConfig={{
            label: 'Select Reconciliation',
            options: reconciliations?.map((item) => item?.name),
            value: selectedModaReconciliation ?? '',
            onSelect: handleSelectOption,
          }}
        />
      )}
      {documentModalOpen && (
        <DocumentViewModal
          open={documentModalOpen}
          handleClose={() => {
            setDocumentModalOpen(false);
            setDocumentToOpen(emptyDocumentDetailsForModal());
          }}
          documentDetails={documentToOpen}
        />
      )}
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </Grid>
  );
};

export default ReconciliationWorkspace;
